import { computed } from 'vue'
import { useRoute } from 'nuxt/app'

import { useExperienceQueryPartition } from '@common/experience-runtime/composables/useExperienceQueryPartition'
import { resolveCpBreadcrumbRegistryKey } from '@common/navigation-layer/config/cp-breadcrumb-registry'
import type { ExperienceQueryPartition } from '@common/experience-runtime/utils/create-experience-query-partition'

import { mapEventDetail } from '../utils/map-event-detail'
import { useEvents } from './useEvents'

export const useEventsDetailBreadcrumbLabel = () => {
  const route = useRoute()
  const partitionContext = useExperienceQueryPartition()
  const queryPartition = partitionContext.queryPartition ?? computed<ExperienceQueryPartition | undefined>(() => undefined)
  const eventId = computed(() => {
    if (resolveCpBreadcrumbRegistryKey(route) !== 'clientportal-events-detail') return undefined
    const raw = route.params.eventId
    const resolved = typeof raw === 'string' ? raw : Array.isArray(raw) ? String(raw[0] ?? '') : ''
    return resolved || undefined
  })
  const events = useEvents(queryPartition)
  const detailQuery = events.fetchEventDetailQuery(eventId)

  return computed(() => {
    if (!eventId.value) return undefined
    const title = mapEventDetail(detailQuery.data.value?.event)?.item.title.trim()
    return title && title.length > 0 ? title : undefined
  })
}
